export default __webpack_public_path__ + "static/media/check-mark.f90cdc79.svg";